const ITEMS = [
  "Professional Travel Service",
  "Custom Itinerary",
  "Hotel & Transport",
  "Local Support",
  "Group & Private Trip",
  "Halal Travel Support",
];

export default function Marquee() {
  return (
    <div className="overflow-hidden border-y border-gold/25 bg-tosca-900 py-4" data-testid="editorial-marquee">
      <div className="flex w-max animate-marquee">
        {[...ITEMS, ...ITEMS].map((t, i) => (
          <span
            key={i}
            aria-hidden={i >= ITEMS.length}
            className="flex items-center gap-10 pr-10 text-[13px] font-semibold uppercase tracking-[0.22em] text-tosca-100"
          >
            {t}
            <span className="inline-block h-1.5 w-1.5 rotate-45 bg-gold" />
          </span>
        ))}
      </div>
    </div>
  );
}
